import React, { useEffect, useState, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { MissionPage } from './pages/MissionPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { PainSolutionPage } from './pages/PainSolutionPage';
import { FindSolutionPage } from './pages/FindSolutionPage';
function useHashRoute() {
  const getRoute = () => window.location.hash;
  const [hash, setHash] = useState(getRoute);
  useEffect(() => {
    const handler = () => setHash(getRoute());
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);
  return hash;
}
function useSEO() {
  useEffect(() => {
    // Page title
    document.title = 'Meelo — ERP система для детских садов в Казахстане';
    // Helper to set or create a meta tag
    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    // Meta description
    setMeta('name', 'description', 'Meelo — система управления детским садом. Циклограммы, меню, журналы, склад, документы и аналитика в одной платформе. Подключение за 2 дня.');
    // Open Graph
    setMeta('property', 'og:title', 'Meelo — ERP система для детских садов');
    setMeta('property', 'og:description', 'Автоматизируйте управление детским садом: меню, циклограммы, документы, финансы и аналитика.');
    setMeta('property', 'og:site_name', 'Meelo');
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:image', 'https://cdn.magicpatterns.com/uploads/bsudF3ForJPFx5q9LjRTna/final_logo_(1).svg');
    // Favicon via link tag
    const setFavicon = (href: string) => {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.type = 'image/svg+xml';
      link.href = href;
    };
    setFavicon('https://cdn.magicpatterns.com/uploads/bsudF3ForJPFx5q9LjRTna/final_logo_(1).svg');
  }, []);
}
function useYandexMetrika() {
  useEffect(() => {
    // Prevent multiple injections
    if (document.getElementById('yandex-metrika')) return;
    const script = document.createElement('script');
    script.id = 'yandex-metrika';
    script.type = 'text/javascript';
    script.innerHTML = `
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(109352452, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true,
            webvisor:true
      });
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/109352452" style="position:absolute; left:-9999px;" alt="" /></div>`;
    document.head.appendChild(noscript);
  }, []);
}
export function App() {
  const hash = useHashRoute();
  useSEO();
  useYandexMetrika();
  if (hash === '#/mission') return <MissionPage data-id="element-0" />;
  if (hash === '#/privacy') return <PrivacyPolicyPage data-id="element-1" />;
  if (hash === '#/find-solution') return <FindSolutionPage data-id="element-2" />;
  if (hash.startsWith('#/find-solution/pain/')) {
    const painId = hash.replace('#/find-solution/pain/', '');
    return <PainSolutionPage painId={painId} data-id="element-3" />;
  }
  // Backward-compat: redirect old #/pain/<id> URLs to the new nested route
  if (hash.startsWith('#/pain/')) {
    const painId = hash.replace('#/pain/', '');
    window.location.replace(`#/find-solution/pain/${painId}`);
    return <PainSolutionPage painId={painId} data-id="element-4" />;
  }
  return <LandingPage data-id="element-5" />;
}